<section class="trust-strip" [attr.aria-label]="'common.trustAriaLabel' | transloco">
  <ul class="chip-list">
    @for (chip of trustChips; track chip) {
      <li class="chip">{{ chip | transloco }}</li>
    }
  </ul>
</section>

<section class="hero">
  <div class="hero-content">
    <!-- Brand mark as the hero centerpiece (not the header — the header keeps
         the compact ianua-logo.svg). The brand SVGs are static (no internal
         dark-mode swap), so <picture> serves the dark variant when the OS
         prefers dark — matching the site's system-follow color-scheme. Decorative:
         the header brand link + the headline already name Ianua, so it's
         aria-hidden to avoid a redundant screen-reader announcement. -->
    <picture class="hero-logo">
      <source srcset="assets/ianua-logo-brand-dark.svg" media="(prefers-color-scheme: dark)" />
      <img src="assets/ianua-logo-brand-light.svg" alt="" aria-hidden="true" />
    </picture>
    <h1 class="hero-headline">{{ 'home.hero.headline' | transloco }}</h1>
    <p class="hero-subhead">{{ 'home.hero.subhead' | transloco }}</p>
    <a
      mat-flat-button
      color="primary"
      routerLink="/signup"
      class="hero-cta"
    >{{ 'home.hero.cta' | transloco }}</a>
    <p class="hero-login">
      {{ 'home.hero.loginPrompt' | transloco }}
      <a [href]="adminSigninUrl" class="hero-login-link">{{ 'home.hero.login' | transloco }}</a>
    </p>
  </div>
</section>

<section class="story" aria-labelledby="story-title">
  <h2 id="story-title" class="story-title">{{ 'home.story.title' | transloco }}</h2>
  <p class="story-intro">{{ 'home.story.intro' | transloco }}</p>

  <div class="story-control">
    <h3 class="story-block-title">{{ 'home.story.sections.control.title' | transloco }}</h3>
    <p class="story-block-body">{{ 'home.story.sections.control.body' | transloco }}<span class="story-latin">— <span lang="la">{{ 'home.story.latin' | transloco }}</span></span></p>
  </div>
</section>

<section class="pillars" [attr.aria-label]="'home.pillarsAriaLabel' | transloco">
  <ul class="pillar-grid">
    @for (pillar of pillars; track pillar.titleKey) {
      <li>
        <mat-card class="pillar-card" appearance="outlined">
          <mat-card-content>
            <mat-icon class="pillar-icon" aria-hidden="true">{{ pillar.icon }}</mat-icon>
            <h2 class="pillar-title">{{ pillar.titleKey | transloco }}</h2>
            <p class="pillar-body">{{ pillar.bodyKey | transloco }}</p>
          </mat-card-content>
        </mat-card>
      </li>
    }
  </ul>
</section>
